import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SidenavComponent } from './sidenav.component';
import { WmInputModule } from '../input/index';
import { SidenavService } from './sidenav.service';
import { WmIconModule } from '../icon/index';
import { WmExpandableModule } from '../expandable/index';
import { RouterModule } from '@angular/router';
import { WmTransitionModule } from '../transition/index';
import { SidenavItemComponent } from './sidenav-item/sidenav-item.component';
import { WmDirectivesModule } from '../../shared/directives/index';

@NgModule({
	declarations: [SidenavComponent, SidenavItemComponent],
	imports: [
		CommonModule,
		WmInputModule,
		WmIconModule,
		WmExpandableModule,
		RouterModule,
		WmTransitionModule,
		WmDirectivesModule
	],
	providers: [SidenavService],
	exports: [SidenavComponent, SidenavItemComponent]
})
export class WmSidenavModule {}
